export enum TariffPlan {
  Basic = 1,
  Annual = 2,
  Infinity = 5,
  Professional = 6,
  Premium = 7,
  No_Tariff = 0
}